import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Tag } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Badge } from "@/components/ui/badge";

const statusStyle = {
  active: "bg-primary/10 text-primary border-primary/20",
  closed: "bg-muted text-muted-foreground border-border",
  scheduled: "bg-chart-4/20 text-amber-700 border-amber-200",
};

export function StatusBadge({ status }) {
  const { t } = useI18n();
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${statusStyle[status]}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />{t(`status.${status}`)}
    </span>
  );
}

export default function QuestionCard({ q, index = 0 }) {
  const { t } = useI18n();
  const closes = new Date(q.closes_at);
  return (
    <Link to={`/question/${q.id}`} data-testid={`question-card-${q.id}`}
      className="group block rounded-lg border border-border bg-card p-6 transition-all hover:-translate-y-1 hover:shadow-md animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}>
      <div className="flex items-center justify-between mb-3">
        <StatusBadge status={q.status} />
        <Badge variant="secondary" className="gap-1 font-normal"><Tag className="h-3 w-3" />{q.category}</Badge>
      </div>
      <h3 className="font-heading text-lg font-bold leading-snug tracking-tight group-hover:text-primary transition-colors">{q.title}</h3>
      <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{q.description}</p>
      <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
        <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{t("q.closes")}: {closes.toLocaleDateString()}</span>
        <span className="font-semibold text-foreground">{q.total_votes} {t("common.votes")}</span>
      </div>
      <div className="mt-3 flex items-center gap-1 text-sm font-semibold text-primary">
        {q.status === "closed" ? t("q.results") : t("q.vote")}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
